import script from "./CaseDetailright.vue?vue&type=script&setup=true&lang=js"
export * from "./CaseDetailright.vue?vue&type=script&setup=true&lang=js"

import "./CaseDetailright.vue?vue&type=style&index=0&id=e131752e&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e131752e"]])

export default __exports__